import classNames from "classnames";
import React from "react";
import styled from "styled-components";
import alert from "assets/images/alert.svg";

function WarningIcon({ className, size }) {
  return (
    <IconStyled $size={size} className={classNames("status-bound status-icon-warning", className)}>
      <img src={alert} alt="warning icon" />
    </IconStyled>
  );
}

export default WarningIcon;

WarningIcon.defaultProps = {
  size: null,
};

const getShadow = (size) => {
  const base = {
    y: 6,
    blur: 20,
    spread: 2,
  };
  const ratio = typeof size === "number"
    ? size / 60
    : (typeof size === "string" && size.endsWith("px"))
      ? parseInt(size, 10) / 60
      : 1;
  const y = (base.y * ratio).toFixed(2);
  const blur = (base.blur * ratio).toFixed(2);
  const spread = (base.spread * ratio).toFixed(2);
  return `0px ${y}px ${blur}px ${spread}px rgba(249, 199, 59, 1)`;
};

const IconStyled = styled.div`
  ${({ $size }) => {
    const shadow = $size ? getShadow($size) : "0px 6px 20px 2px rgba(249, 199, 59, 1)";
    return `
      background: var(--ktb-yellow-gradient);
      box-shadow: ${shadow};
      -webkit-box-shadow: ${shadow};
      -moz-box-shadow: ${shadow};
      ${$size ? `
        width: ${typeof $size === "number" ? `${$size}px` : $size};
        height: ${typeof $size === "number" ? `${$size}px` : $size};
        img {
          width: 56%;
          height: 56%;
          object-fit: contain;
        }
      ` : ""}
    `;
  }}
`;
